/**
 *
 */
(function(window, undefined) {
  'use strict';
  var CdintUserSrvc = function() {
    this.user;
    this.abilitazioni;
    this.abilitazioniPronte;
    this.labelsPronte;
  };

  CdintUserSrvc.$inject = [];

  angular
    .module('cbl.cartadebitoint.wa')
    .service('CdintUserSrvc', CdintUserSrvc);
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/userSrvc.js
// module id = 28
// module chunks = 0